import { render, staticRenderFns } from "./CombinedVisitRadiology.vue?vue&type=template&id=98301c6c&"
import script from "./CombinedVisitRadiology.vue?vue&type=script&lang=js&"
export * from "./CombinedVisitRadiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports